export type AppWorkspaceRoot =
  | { kind: 'chat'; id: string }
  | { kind: 'resource'; id: string };

const WORKSPACE_PATH = '/workspace';
const ROOT_PREFIX = { chat: 'c', resource: 'r' } as const;

/** Canonical browser and API path for an individual chat or resource. */
export const getWorkspaceRootPath = (root: AppWorkspaceRoot): string => {
  return `${WORKSPACE_PATH}/${ROOT_PREFIX[root.kind]}-${encodeURIComponent(root.id)}`;
};

export const getWorkspacePath = (): string => WORKSPACE_PATH;

/** Read a canonical root while leaving unrelated application paths alone. */
export const parseWorkspaceRoot = (pathname: string): AppWorkspaceRoot | null => {
  const match = pathname.match(/^\/workspace\/(c|r)-([^/]+)\/?$/);

  if (!match) {
    return null;
  }

  try {
    const id = decodeURIComponent(match[2]).trim();

    if (!id || id.includes('/')) {
      return null;
    }

    return { kind: match[1] === 'c' ? 'chat' : 'resource', id };
  } catch {
    return null;
  }
};
